<template>
  <div class="actions" v-if="!$store.getters['user/account'] || $store.getters['user/isHirer']">
    <div class="action">
      <book-button :listing="listing" type="booking"></book-button>
    </div>
    <div class="action">
      <book-button :listing="listing" type="recce"></book-button>
    </div>
  </div>
</template>

<script>
import BookButton from './BookButton'

export default {
  components: {
    BookButton
  },
  props: {
    listing: {
      type: Object,
      required: true
    }
  }
}
</script>
